import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
  size?: 'normal' | 'large';
}

export default function DramaCard({ drama, size = 'normal' }: DramaCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block"
    >
      <div className={`relative overflow-hidden rounded-lg ${isLarge ? 'aspect-[16/9]' : 'aspect-[3/4]'}`}>
        <img
          src={drama.coverImage}
          alt={drama.title}
          title={`${drama.title} - 桃子影院电视剧全集在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />

        <div className="absolute top-2 left-2 flex items-center gap-2 flex-wrap">
          {drama.isNew && (
            <span className="px-2 py-0.5 rounded text-xs bg-primary-500 text-background-50 whitespace-nowrap">
              最新
            </span>
          )}
          {drama.isHot && !drama.isNew && (
            <span className="px-2 py-0.5 rounded text-xs bg-accent-500 text-background-950 whitespace-nowrap">
              热播
            </span>
          )}
          {drama.status === '连载中' && (
            <span className="px-2 py-0.5 rounded text-xs bg-background-800/80 text-foreground-300 whitespace-nowrap">
              连载
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded text-xs bg-background-950/70 text-accent-400 whitespace-nowrap">
            {drama.rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-foreground-100 text-sm md:text-base font-heading truncate group-hover:text-primary-400 transition-colors">
            {drama.title}
          </h3>
          <div className="flex items-center gap-2 mt-1 text-foreground-500 text-xs">
            <span>{drama.year}</span>
            <span>·</span>
            <span>{drama.subCategory}</span>
            <span>·</span>
            <span>{drama.status === '连载中' ? `更新至${drama.currentEpisode}集` : `${drama.totalEpisodes}集全`}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}